// import { useState } from "react";
// import Background from '/assets/images/footer-image.jpg';

import { Fade } from "react-reveal"
import { FOOTER_RIGHT_TITLE } from "../constants";
import { Link, NavLink } from "react-router-dom";

const Footer = () => {
    //const [footerBg, setFooterBg] = useState('../../client/public/assets/images/footer-image.png');

    return (
        // <div className="footer d-flex flex-column justify-content-center align-items-center bg-secondary">
        //     <div className="container">
        //         <div className="row no-gutters no-border">

        //             <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center p-5">
        //                 <img src="/assets/icons/brand-logo-full-white.svg" alt="brand-logo" />
        //                 <p>Minimal and Organic</p>
        //             </div>

        //             <div className="contact-us-main-div col-12 col-md-6 d-flex flex-column justify-content-start align-items-center p-5">
        //                 <div>Get your work done<br />wonderfully!</div>
        //                 <div id="contact-us">
        //                     <span>contact us <img id="contact-us-arrow" src="/assets/icons/arrow_right_icon.svg" alt="arrow" /></span>
        //                 </div>
        //                 <div id="socials">
        //                     <span className="contact-us-icon">
        //                         <img id="contact-us-arrow" src="/assets/icons/icon_instagram.svg" alt="arrow" />
        //                     </span>
        //                     <span className="contact-us-icon">
        //                         <img id="contact-us-arrow" src="/assets/icons/icon_facebook.svg" alt="arrow" />
        //                     </span>
        //                     <span className="contact-us-icon">
        //                         <img id="contact-us-arrow" src="/assets/icons/icon_whatsapp.svg" alt="arrow" />
        //                     </span>
        //                 </div>
        //             </div>

        //         </div>
        //     </div>

        // </div>

        <div className="footer d-flex flex-column justify-content-center align-items-center"
        // style={{ backgroundImage: `url(${Background})` }}
        >
            <Fade duration={1500}>
                <div className="container">
                    <div className="row no-gutters no-border">

                        {/* <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center p-4 p-md-5">
                        <img id="footer-logo" src="/assets/icons/brand-logo-full-white.svg" alt="brand-logo" />
                        <p id="footer-logo-text">Minimal and Organic</p>
                    </div> */}

                        <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center p-4 p-md-5">
                            <img className='brand-logo' src="/assets/icons/brand-logo-white-orange.svg" alt="brand-logo" />
                            <img className='brand-logo-full' src="/assets/icons/brand-logo-white-orange.svg" alt="brand-logo" />
                            <p id="footer-logo-text">Minimal and Organic</p>
                        </div>

                        <div className="contact-us-main-div col-12 col-md-6 d-flex flex-column justify-content-start align-items-center p-4 p-md-5">
                            <div>

                                <p className="multi-line footer-logo-text">{FOOTER_RIGHT_TITLE}</p>


                                <div id="contact-us">
                                    <Link to="/contact" style={{ textDecoration: 'none', color: '#ffffff' }}>
                                        <span>
                                            contact us <img id="contact-us-arrow" src="/assets/icons/arrow_right_icon.svg" alt="arrow" />
                                        </span>
                                    </Link>
                                </div>
                                <div id="socials">
                                    <span className="contact-us-icon">
                                        <a href="https://www.instagram.com/minganic_designs/" target="_blank"><img src="/assets/icons/icon_instagram.svg" alt="instagram" /></a>
                                    </span>
                                    <span className="contact-us-icon">
                                        <a href="https://www.facebook.com/minganicdesigns/" target="_blank"><img src="/assets/icons/icon_facebook.svg" alt="facebook" /></a>
                                    </span>
                                    <span className="contact-us-icon">
                                        <a href="http://" target="_blank"><img src="/assets/icons/icon_linkedin.svg" alt="whatsapp" /></a>
                                    </span>
                                    <span className="contact-us-icon">
                                        <a href="http://" target="_blank"><img src="/assets/icons/icon_twitter.svg" alt="twitter" /></a>
                                    </span>
                                </div>
                            </div>

                        </div> {/* contact-us-main-div  end */}

                    </div> {/* row end */}
                </div> {/* container end */}

                {/* Copyright */}
                <div className="container" id="footer-cr">
                    <img id="copyright-img" src="/assets/icons/copyright.svg" alt="" />
                </div>
            </Fade>
        </div>

    );
}

export default Footer;